'use strict'

import axios from 'axios';

const state = {
  history: [],
  pagination: {
    _total_items: 1,
    _per_page: 100,
    _page: 1,
    _page_count: 1
  }
}

const actions = {
  getHistory ({commit, dispatch}, {vacancyId}) {
    return axios.get(`/v2/vacancies/${vacancyId}/url-history`, {
      params: {
        per_page: state.pagination._per_page
      }
    })
      .then(response => {
        commit('setHistory', response.data)
      })
      .catch(err => {
        return Promise.reject(err);
      })
  }
}

const mutations = {
  setHistory (state, data) {
    state.history = data && data._embedded && data._embedded.remind_templates ? data._embedded.remind_templates : [];
    state.pagination = {
      _total_items: data._total_items,
      _per_page: data._per_page,
      _page: data._page,
      _page_count: data._page_count
    }
  }
}

const getters = {
  history (state) {
    return state.history
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
